import { API_LOCATION_URL } from 'infrastructure/config';
import { IPostInput, IPostResponse, IBuyerSendChatClient } from 'interfaceAdapter/gatewaySchemas/IBuyerSendChatClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/buyer/send_chat`;

export class BuyerSendChatClient implements IBuyerSendChatClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, chat_room_id, message } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({ chat_room_id: chat_room_id, message: message });

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
